import { gql } from "@apollo/client";
import { ExhibitionWork as exhibitionWork } from "../fragments";

const FETCH_EXHIBITION_WORKS = props => gql`
	query FetchExhibitionWorks($input: ExhibitionWorksInput!) {
		exhibitionWorks(input: $input) {
			count
			edges {
				${exhibitionWork(props)}
			}
		}
	}
`;

const FETCH_EXHIBITION_WORKS_V2 = props => gql`
  query FetchExhibitionWorksV2($input: AdvExhibitionWorkFilterInput!) {
    exhibitionWorksV2(input: $input) {
      count
      edges {
        ${exhibitionWork(props)}
      }
      sqlQuery
    }
  }
`;

export { FETCH_EXHIBITION_WORKS, FETCH_EXHIBITION_WORKS_V2 };
